// extracted by mini-css-extract-plugin
export var desktopTeasers = "TeaserView-module--desktopTeasers--79d85";
export var layoutOverlay = "TeaserView-module--layoutOverlay--1de71";
export var mediaSliderControls = "TeaserView-module--mediaSliderControls--a0609";
export var mobileTeasers = "TeaserView-module--mobileTeasers--a0580";